import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { metadatas } from '@sorare/core/src/lib/seo/common';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { AboutUs } from './AboutUs/index.tsx';
import { ByTheNumbers } from './ByTheNumbers/index.tsx';
import { HowToPlay } from './HowToPlay/index.tsx';
import { InTheNews } from './InTheNews/index.tsx';
import { Intro } from './Intro/index.tsx';
import { Leadership } from './Leadership/index.tsx';

const Root = styled(Vertical).attrs({
  gap: 4,
  center: true,
})`
  margin-top: var(--double-unit);
  @media ${tabletAndAbove} {
    padding: var(--double-unit);
  }
`;

export const Press = () => {
  useTitleAndDescription(metadatas.press.title);

  return (
    <Root>
      <Intro />
      <AboutUs />
      <HowToPlay />
      <ByTheNumbers />
      <Leadership />
      <InTheNews />
    </Root>
  );
};
